export enum WipStatusE {
  Pending = 'Pending',
  Working = 'Working',
  Completed = 'Completed',
}

export enum WipPriorityE {
  Undefined = 'Undefined',
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  Critical = 'Critical',
}

export enum RepairOrderStatusE {
  Pending = 'Pending',
  OpenProcessing = 'OpenProcessing',
  OpenCompleted = 'OpenCompleted',
  ClosedProcessing = 'ClosedProcessing',
  ClaimsCompleted = 'ClaimsCompleted',
  ClaimsBalanced = 'ClaimsBalanced',
  ClosedCompleted = 'ClosedCompleted',
  NotWarranty = 'NotWarranty',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
}

export enum WipSortFieldE {
  RepairOrderNumber = 'RepairOrderNumber',
  Dealership = 'Dealership',
  AdvisorNumber = 'AdvisorNumber',
  TechNumber = 'TechNumber',
  Oem = 'Oem',
  Priority = 'Priority',
  CreatedAt = 'CreatedAt',
  OemPaidDate = 'OemPaidDate',
  SubmittedDate = 'SubmittedDate',
}

export enum WipSortOrderE {
  Asc = 'asc',
  Desc = 'desc',
}
